<template>
  <div class="modal fade" id="emandateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header"><button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button></div>
            
              
                    <img class="img-fluid" src="../../assets/images/PopUP-Payment-3.png">
                  
              
          </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      accept:false,
      img_location: require("@/assets/images/termnconditon.png"),
    }
  },
  methods: {
    onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight >= scrollHeight - clientHeight) {
        this.accept = true;
      }
    }
  }
}
</script>

<style scoped>
p + p {
  margin-top: 6px;
}
tr {
  vertical-align: top;
}
td:first-child {
  width: 2rem;
}
td + td {
  padding-left: 1rem;
}
</style>